<template>
    <app-form-group
        :class="{'loading-opacity disabled': loading}"
        :page="page"
        :type="type"
        :model-value="model"
        @update:model-value="handleInput"
        v-bind="$attrs"
        :list="arrays"
        :form-group-class="formGroupClass"
        :id="fieldId"
        :recommendation="recommendation"
    >
        <template #suggestion>
            <app-input
                v-if="chooseAll"
                type="single-checkbox"
                v-model="isAll"
                :listValueField="$t('choose_all')"
                labelClass="mt-2"
                :id="`${fieldId}-choose`"
            />
        </template>
    </app-form-group>
</template>

<script>
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {addChooseInSelectArray} from "../../../common/Helper/Support/FormHelper";

export default {
    name: "AppFromGroupSelectable",
    inheritAttrs: false,
    emits: ['input', 'update:modelValue'],
    props: {
        page: {
            required: false,
            default: 'modal'
        },
        type: {
            required: false,
            default: 'search-select'
        },
        value: {
            default: ''
        },
        // Vue 3 v-model
        modelValue: {
            default: undefined
        },
        chooseLabel: {
            default: false
        },
        fetchUrl: {
            type: String,
            required: true
        },
        formGroupClass: {
            type: String
        },
        chooseAll: {
            type: Boolean,
            default: false
        },
        recommendation: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            model: [],
            arrays: [],
            loading: true,
            isAll: false
        }
    },
    computed: {
        fieldId() {
            const uid = this.$ && this.$.uid !== undefined ? this.$.uid : Math.random().toString(36).slice(2);
            return 'selectable_' + uid;
        }
    },
    methods: {
        handleInput(value) {
            this.model = value;
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
        },
        getData() {
            this.loading = true;
            axiosGet(this.fetchUrl).then(response => {
                if (this.chooseLabel) {
                    const valueField = this.$attrs['list-value-field'] ? this.$attrs['list-value-field'] : 'name';
                    this.arrays = addChooseInSelectArray(response.data, valueField, this.chooseLabel)
                } else {
                    this.arrays = response.data
                }
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    watch: {
        value: {
            handler: function (value) {
                if (value !== undefined) this.model = value;
            },
            immediate: true
        },
        modelValue: {
            handler: function (value) {
                if (value !== undefined) this.model = value;
            },
            immediate: true
        },
        fetchUrl: {
            handler: function () {
                this.getData();
            },
            immediate: true
        },
        'model.length': function (length) {
            if (!length) {
                this.isAll = false;
            }
        },
        isAll: function (isAll) {
            if (isAll) {
                this.model = this.collection(this.arrays).pluck();
                this.handleInput(this.model);
            }
        }
    }
}
</script>
